function deepClone(value) {
  // structuredClone is ~2-3x faster than JSON round-tripping and does not choke
  // on the numeric edge cases; fall back where it is unavailable.
  if (typeof structuredClone === 'function') {
    try { return structuredClone(value); } catch (_) { /* fall through */ }
  }
  return JSON.parse(JSON.stringify(value));
}

export function cloneMatchForLocalSession(match, maxUndoEntries = 12) {
  if (!match) return null;
  // Slice the undo ring BEFORE cloning. The old order serialised the whole
  // match plus all 12 nested historical snapshots and only then threw most of
  // them away — a ~1.3 MB synchronous serialise on every single delivery.
  const { _undoStack, _recoveryCheckpoints, ...rest } = match;
  const snapshot = deepClone(rest);
  snapshot._undoStack = Array.isArray(_undoStack)
    ? _undoStack
        .filter(entry => entry && typeof entry === 'object' && entry.teamA && entry.teamB && Array.isArray(entry.innings))
        .slice(-Math.max(0, maxUndoEntries))
        .map(deepClone)
    : [];
  return snapshot;
}
